function iPhoneSafari() {
  const ua = navigator.userAgent.toLowerCase();
  return (
    ua.indexOf('iphone') > -1
    && ua.indexOf('safari') > -1
    && ua.indexOf('chrome') === -1
  );
}

export default iPhoneSafari;



// WEBPACK FOOTER //
// ./javascript/utils/iPhoneSafari.js